export const ADMIN_PATH = '/admin';
export const ADMIN_NAV_BAR_HEIGHT = `calc(5rem + env(safe-area-inset-top))`;
export const ADMIN_MAIN_HEADER_HEIGHT = `4rem`;

export const isExperimentalATSActive =
  import.meta.env.VITE_EXPERIMENTAL_ATS_ACTIVE === 'true';
